var bannerScreenWidthCheck = 0;

function setVideo() {
    var screenWidth = window.innerWidth;

    // Only do this if the screen width has checked since the last recoreded size. The resize appears to be updating on scroll.
    if (bannerScreenWidthCheck != screenWidth) {

        bannerScreenWidthCheck = screenWidth;

        var mainVideo = document.querySelector(".video-autoplay, .banner-video-container");

        if (mainVideo) {
            // if window width is smaller than 1024, assume mobile device. Using 1024 as mobile device screen resolution is quite large these days
            if (screenWidth < 1024) {
                var screenHeight = window.innerHeight;

                var videoOverlay = document.querySelector(".video-overlay");

                if (mainVideo.hasAttribute("data-video-src-mobile")) {
                    videoOverlay.style.display = "block";

                    // empty the existing video from the container and switch off autoplay on mobile
                    mainVideo.innerHTML = "";
                    mainVideo.removeAttribute('autoplay');

                    var videoUrl = mainVideo.dataset.videoSrcMobile;

                    // add new video and load it
                    mainVideo.append('<source type=\'video/mp4\' src=\'' + videoUrl + '\' />');
                    mainVideo.setAttribute('src', videoUrl);
                    //mainVideo.get(0).load();

                    document.querySelector(".video-overlay").classList.remove("playing");
                }
                else {
                    videoOverlay.style.display = "none";

                    mainVideo.innerHTML = "";
                    mainVideo.setAttribute("src", "");
                }

            } else {
                if (mainVideo.hasAttribute("data-video-src-desktop")) {

                    var videoUrl = mainVideo.dataset.videoSrcDesktop;

                    // empty existing video from the container
                    mainVideo.innerHTML = "";

                    // add new video, set it to autoplay on desktop then load and play it to make sure it plays
                    mainVideo.append('<source type=\'video/mp4\' src=\'' + videoUrl + '\' />');
                    mainVideo.setAttribute('src', videoUrl);
                    mainVideo.setAttribute('autoplay', 'true');
                }
                else {
                    mainVideo.innerHTML = "";
                    mainVideo.setAttribute("src", "");
                }
            }
        }
    }
}

document.addEventListener(
    "DOMContentLoaded", () => {
        setVideo();
    }
);

window.addEventListener(
    "resize", () => {
        setVideo();
    }
);


document.querySelector('.video-overlay-click')?.addEventListener(
    "click", event => {
        event.stopPropagation();

        if (window.innerWidth < 1024) {
            document.querySelector('.video-wrapper').classList.add("playing");

            var video = document.querySelector('.video-autoplay, .banner-video-container');
            video.play();
        }
    }
);

document.querySelector('.video-overlay')?.addEventListener(
    "click", event => {
        event.stopPropagation();

        if (window.innerWidth < 1024) {
            document.querySelector('.video-wrapper').classList.remove("playing");

            var video = document.querySelector('.video-autoplay, .banner-video-container');
            video.pause();
        }
    }
);
